// You can write more code here

import { HorizontalLayoutGroup } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/HorizontalLayoutGroup';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import SquareSelectableCard from '../GeneralUI/SquareSelectableCard';
import SpellIcon, { SpellID } from './SpellIcon';

/* START OF COMPILED CODE */

export default class SpellSelectionUI extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // iconContainer
    const iconContainer = scene.add.container(0, 32);
    this.add(iconContainer);

    this.iconContainer = iconContainer;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private iconContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  private spellButtons: SpellIcon[] = [];
  private currentSpell: SpellID | null = null;

  awake() {
    const availableSpells = [
      SpellID.fireball,
      SpellID.iceBlast,
      SpellID.arcaneBlast,
    ];

    for (var i = 0; i < availableSpells.length; i++) {
      // Create a spell button.
      const spellButton = new SpellIcon(this.scene, 0, 0).awake({
        spellId: availableSpells[i],
        index: i,
        onCardSelected: this.handleCardSelected.bind(this),
      });
      this.spellButtons.push(spellButton);
      this.iconContainer.add(spellButton);
    }

    // Create a Horizontal Layout Group for the spell icons.
    const layoutGroup = new HorizontalLayoutGroup({
      parent: this.iconContainer,
      origin: new Phaser.Math.Vector2(0, 0),
      elementDist: 16,
      align: 'center',
    });

    layoutGroup.updateLayout();

    // Responsiveness.
    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      anchor.add(this, {
        centerX: '50%',
      });
    }

    // Select the first spell.
    this.handleCardSelected(this.spellButtons[0], false);

    return this;
  }

  handleCardSelected(card: SquareSelectableCard, playSFX: boolean = true) {
    if (!card.isSelected) {
      this.spellButtons.forEach((spellCard) => {
        spellCard.deselectCard();
      });
      card.selectCard(playSFX);
      this.currentSpell = (card as SpellIcon).spell;
    }
  }

  getCurrentSpellID() {
    if (this.currentSpell === null) return null;
    return this.currentSpell;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
